export default function Hero({position, marginbtm, img}) {
    return (
        <>
        <div className={`${position} md:relative mb-${marginbtm}`}>
        <img
            src={img}
            className="absolute inset-0 object-fill w-full"
            alt=""
        />
        </div>
        </>
    );
};